import {
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import {
  FactoringBuyback,
  FactoringResellWithFund,
} from '../../../../../../services/redux/documentProfileSlice.types';
import { formatDate, formatMoney } from '../../../../../functions/utils';

type FactoringResellTooltipProps = {
  resell: FactoringResellWithFund;
};

const sortBuybacksByDateDesc = (a: FactoringBuyback, b: FactoringBuyback) => {
  const dateA = new Date(a.buybackAt).getTime();
  const dateB = new Date(b.buybackAt).getTime();
  return dateB - dateA;
};

const FactoringResellTooltip: React.FC<FactoringResellTooltipProps> = ({
  resell,
}) => {
  const buybacks = (resell.buybacks ?? []).slice().sort(sortBuybacksByDateDesc);
  const hasBuybacks = buybacks.length > 0;

  return (
    <Box sx={{ p: 1, minWidth: 360 }}>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 700,
          mb: 1.25,
          fontSize: '0.875rem',
          textAlign: 'left',
        }}
      >
        Venta a fondo
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Fondo
          </Typography>
          <Typography variant="body2">
            {resell.fund?.name ?? '-'}{' '}
            {resell.fund?.id ? `(${resell.fund.id})` : ''}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Monto
          </Typography>
          <Typography variant="body2">{formatMoney(resell.amount)}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Fecha venta
          </Typography>
          <Typography variant="body2">
            {formatDate(new Date(resell.startDate), 'dd-mm-yyyy')}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Vencimiento
          </Typography>
          <Typography variant="body2">
            {formatDate(new Date(resell.dueDate), 'dd-mm-yyyy')}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 700,
          mb: 1,
          fontSize: '0.875rem',
          textAlign: 'left',
        }}
      >
        Recompras
      </Typography>

      {!hasBuybacks ? (
        <Typography variant="body2" color="text.secondary">
          Sin recompras registradas
        </Typography>
      ) : (
        <Table size="small" sx={{ minWidth: 360 }}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight="bold">
                  Fecha
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight="bold">
                  Monto
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {buybacks.map((buyback) => (
              <TableRow key={buyback.id}>
                <TableCell>
                  <Typography variant="body2">
                    {formatDate(new Date(buyback.buybackAt), 'dd-mm-yyyy')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {formatMoney(buyback.amount)}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};

export default FactoringResellTooltip;
